import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Fab from "@material-ui/core/Fab";
import CheckIcon from "@material-ui/icons/Check";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
// import { Alert, AlertTitle } from '@material-ui/lab';
import {
  makeStyles,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";
import remy from "/usr/src/app/client/img/unnamed.png";
import clsx from "clsx";
import CircularProgress from "@material-ui/core/CircularProgress";
import { green } from "@material-ui/core/colors";
import Kfunc from "../utill/util";
import { Formik, Form } from "formik";
import * as yup from "yup";

let SignupSchema = yup.object().shape({
  firstName: yup.string().required("This field is required."),
  lastName: yup.string().required("This field is required."),
  email: yup.string().email().required("This field is required."),
  password: yup
    .string()
    .min(6, "Password is too short.")
    .max(20, "Password is too long.")
    .required("This field is required."),
});
function _interopDefault(ex) {
  return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}
// var React__default = _interopDefault(React);
var axios = _interopDefault(require("axios"));
var url = _interopDefault(require("url"));
var qs = _interopDefault(require("qs"));
// var querystring = _interopDefault(require("querystring"));
///////////////////////////UseStay//////////////////////////
const useStyles = makeStyles((theme) => ({
  "@global": {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  large: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    margin: theme.spacing(3, 0, 2),
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
  fabProgress: {
    color: green[500],
    position: "absolute",
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonSuccess: {
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
    margin: {
      margin: theme.spacing(1),
    },
  },
}));
export default function Les1() {
  const classes = useStyles();
  // const [payload, setPayload] = useState(null);
  const [idToken, setIdToken] = useState(null);
  const [password, setpassword] = useState("");
  const [phone, setphone] = useState();
  const [Name, setName] = useState();
  const [Fname, setFname] = useState();
  const [Lname, setLname] = useState();
  const [brance, setbrance] = useState();
  const [Lineregis, setLineregis] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [status, setstatus] = useState(true);
  const [Show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState("");
  const [feth, setfeth] = useState(false);
  const handleClose = () => {
    setOpen(false);
    window.location.href = `https://linetoken.prachakij.com/`;
  };
  const buttonClassname = clsx({
    [classes.buttonSuccess]: success,
  });
  const timer = React.useRef();

  React.useEffect(function () {
    getAccessToken(window.location.href);
  }, []);

  React.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  React.useEffect(() => {
    handleButtonClick2();
  }, [feth]);

  // const handleButtonClick = () => {
  //   if (!loading) {
  //     setSuccess(false);
  //     setLoading(true);
  //     timer.current = window.setTimeout(() => {
  //       setSuccess(true);
  //       setLoading(false);
  //     }, 2000);
  //   }
  // };
  // ////////////////////////
  const handleButtonClick2 = async () => {
    if (feth === true) {
      try {
        var jsondata5 = {
          message: `ลงทะเบียน Token เรียบร้อยค่ะ\n
          ID สมาชิก :: ${phone}\n
          ชื่อ-นามสกุล :: ${Name}\n
          สาขา :: ${brance}`,
          // message: `กลุ่ม :${Lineregis} => ลงทะเบียนรับแจ้งเตือนสำเร็จ ${phone}  ${Name}  ${brance}`,
          url: "https://notify-api.line.me/api/notify",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${idToken}`,
          },
        };

          var jsondataAd = {
          message: `มีสมาชิกลงทะเบียน Token  กรุณากดบันทึก Token  ด้วยค่ะ\n
          อย่าลืมบันทึกข้อมูลใน BCT จัดเก็บ Line Token ด้วยนะ\n
          http://ags.im/UFcJh7\n
          ID สมาชิก :: ${phone}\n
          ชื่อ-นามสกุล :: ${Name}\n
          สาขา :: ${brance}`,
          // message: `กลุ่ม :${Lineregis} => ลงทะเบียนรับแจ้งเตือนสำเร็จ ${phone}  ${Name}  ${brance}`,
          url: "https://notify-api.line.me/api/notify",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer JvfjjfzCAq3bpW27zpbbtamFZOcf95vaBA3Nb3A03dg`,
          },
        };
        const notify = await Kfunc.fecth(jsondata5);
        const notify2 = await Kfunc.fecth(jsondataAd);
        // alert(JSON.stringify(notify))
        const body2 = {
          "#": "X",
          namegroup: Lineregis,
          token: idToken,
          id_emp: phone,
          lname: Lname,
          fname: Fname,
          bu: brance,
        };
        var uri =
          "https://script.google.com/macros/s/AKfycbz4EC-zUe7BTJ09-CUchTSQ0pivh-SyqTkdjCVO-7cXlz6G-dA/exec?path=/line_pgh&method=POST";
        var jsondata = {
          insert: body2,
          url: uri,
          path: "inserttoken",
          port: "5003",
        };
        const BCT = await Kfunc.fetchlocal(jsondata);
        console.log(BCT);
      } catch (error) {
        alert(JSON.stringify(error));
      }
    }
  };

  var getAccessToken = function getAccessToken(callbackURL) {
    var urlParts = url.parse(callbackURL, true);
    var query = urlParts.query;
    var hasCodeProperty = Object.prototype.hasOwnProperty.call(query, "code");
    console.log(query);
    if (query.code == "" || query.code == undefined) {
      setErrorMessage("ลิมิตเต็มกรุณาเปลี่ยนบัญชี!");
      setOpen(true);
      return;
    }

    // console.log(hasCodeProperty);
    // var FLname = `${Fname} ${Lname}`
    if (hasCodeProperty) {
      const start = async () => {
        // var param = query.state.split(",");
        // var Sname = param[2].split(" ");
        // if (Sname !== undefined) {
        //   setphone(param[0]);
        //   setFname(Sname[1]);
        //   setLname(Sname[2]);
        //   setName(param[2]);
        //   // setName(`sadasdasdasdas`);
        //   setbrance(param[3]);
        //   console.log(param);
        //   console.log(Sname);
        // }
        setSuccess(false);
        setLoading(true);
        var jsondata = {
          grant_type: "authorization_code",
          code: query.code,
          redirect_uri: "https://linetoken.prachakij.com/register",
          client_id: "G26i7CWxYxALnVGq6Y8KqX",
          client_secret: "2CVtrw2YGfLSfCIdKetQ9v9JcoTubguEiPNE7oyDo60",
          url: "https://notify-bot.line.me/oauth/token",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        };
        const fecthtoken = await Kfunc.fecth(jsondata);
        if (fecthtoken.error) {
          setErrorMessage("เกิดข้อผิดพลาดร้องขอโทเค็นกรุณาติดต่อทีมงาน!");
          setOpen(true);
          return;
          // return alert("error");
        }
        console.log(fecthtoken);
        // alert(brance);
        var jsondata2 = {
          url: "https://notify-api.line.me/api/status",
          headers: {
            Authorization: `Bearer ${fecthtoken.access_token}`,
          },
        };
        setIdToken(fecthtoken.access_token);
        const getstatus = await Kfunc.getstatus(jsondata2);
        if (getstatus.error) {
          setErrorMessage("เกิดข้อผิดพลาดสถานะกรุณาติดต่อทีมงาน!");
          // setstatus(false);
          setOpen(true);
          return;
        }

        if (getstatus.targetType === "USER") {
          setErrorMessage("ลงทะเบียนแบบกลุ่มเท่านั้นกรุณาเลือกใหม่!");
          // setstatus(false);
          setOpen(true);
          return;
        }
        console.log(getstatus);
        // var jsondata3 = {
        //   message: `${getstatus.target} ลงทะเบียนรับแจ้งเตือนสำเร็จ ${phone}  ${Name}  ${brance}`,
        //   url: "https://notify-api.line.me/api/notify",
        //   headers: {
        //     "Content-Type": "application/x-www-form-urlencoded",
        //     Authorization: `Bearer ${fecthtoken.access_token}`,
        //   },
        // };
        // const notify = await Kfunc.fecth(jsondata3);
        timer.current = window.setTimeout(() => {
          setSuccess(true);
          setLoading(false);
          setLineregis(getstatus.target);
          var param = query.state.split(",");
          var Sname = param[2].split(" ");
          setphone(param[0]);
          setFname(Sname[1]);
          setLname(Sname[2]);
          setName(param[2]);
          // setName(`sadasdasdasdas`);
          setbrance(param[3]);
          console.log(param);
          console.log(Sname);
          // handleButtonClick2()
          setShow(true);
          setfeth(true);
        }, 2000);

        // handleButtonClick();
      };
      start();
    }
  };

  //   return (
  //     <div>
  //       {idToken !== null ? (
  //         <TextField
  //           disabled
  //           id="filled-disabled"
  //           label="TOKEN"
  //           value={idToken}
  //           variant="filled"
  //           fullWidth
  //           name="number"
  //         />
  //       ) : null}
  //     </div>
  //   );
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        {/* <Typography component="h1" variant="h5">
          สมัครรับแจ้งเตือน {phone}
          {Name}
          {idToken}
          {Lineregis}
        </Typography> */}
        {status === true ? (
          <div className={classes.wrapper}>
            <Fab
              aria-label="save"
              color="primary"
              className={buttonClassname}
              // onClick={handleButtonClick}
            >
              {success ? <CheckIcon /> : <SaveIcon />}
            </Fab>
            {loading && (
              <CircularProgress size={68} className={classes.fabProgress} />
            )}
            <Dialog
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"เกิดข้อผิดพลาด:"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {ErrorMessage}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                  ตกลง
                </Button>
              </DialogActions>
            </Dialog>
          </div>
        ) : null}
        <Formik
          initialValues={{
            firstName: "",
            lastName: "",
            email: "",
            password: "",
          }}
          validationSchema={SignupSchema}
          onSubmit={(values) => {
            console.log(values);
          }}
        >
          {/* {({ errors, handleChange, touched }) => ( */}
          {Show === true ? (
            <Form className={classes.form}>
              <h1>รับแจ้งเตือนสำเร็จ</h1>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  {/* {password === true ? ( */}
                  {/* {handleButtonClick2()} */}
                  <TextField
                    disabled
                    id="filled-disabled"
                    label="รหัสพนักงาน"
                    value={phone}
                    variant="filled"
                    fullWidth
                    name="number"
                  />
                  {/* ) : null} */}
                </Grid>
                <Grid item xs={12}>
                  {/* {password === true ? ( */}
                  <TextField
                    disabled
                    id="filled-disabled"
                    label="ชื่อ-นามสกุล"
                    value={Name}
                    variant="filled"
                    fullWidth
                    name="number"
                  />
                  {/* ) : null} */}
                </Grid>
                <Grid item xs={12}>
                  {/* {password === true ? ( */}
                  <TextField
                    disabled
                    id="filled-disabled"
                    label="รับแจ้งเตือนที่"
                    value={Lineregis}
                    variant="filled"
                    fullWidth
                    name="number"
                  />
                </Grid>
              </Grid>
            </Form>
          ) : null}
        </Formik>
      </div>
    </Container>
  );
}



// WEBPACK FOOTER //
// src/page/les1.js